import React from 'react';
import { Terminal as TerminalIcon } from 'lucide-react';

interface TerminalProps {
  children: React.ReactNode;
}

export function Terminal({ children }: TerminalProps) {
  return (
    <div className="w-full h-[600px] bg-black rounded-lg shadow-xl border border-cyan-500/20 flex flex-col overflow-hidden font-mono">
      <div className="flex items-center gap-2 px-4 py-2 bg-black border-b border-cyan-500/20">
        <div className="flex gap-2">
          <div className="w-3 h-3 rounded-full bg-red-500" />
          <div className="w-3 h-3 rounded-full bg-yellow-500" />
          <div className="w-3 h-3 rounded-full bg-green-500" />
        </div>
        <div className="flex-1 text-center">
          <span className="text-sm font-medium text-cyan-500">ARCADIA TERMINAL v1.0.0</span>
        </div>
      </div>
      <div className="flex-1 overflow-hidden flex flex-col bg-black text-cyan-500">
        {children}
      </div>
    </div>
  );
}